import React from 'react';
import SmartImage from '../../subcomponents/SmartImage';
import Cta from '../../subcomponents/Cta';
import findAltText from '../../utils';

import './tech.scss';

const KidsCorner = React.lazy(() => import('../../icons/KidsCorner'));

function Tech({ element, url, isBootroom, version, campaignType, order }) {
  const {
    cta,
    techNumber,
    kidsColor,
    position,
    titleColor,
    mobileTitleColor,
    textColor,
    mobileTextColor,
    useMobileText,
    noBackground,
    backgroundColor,
    hide,
    textAnimation = '',
    imageAnimation = '',
    type,
    anchorName,
    roundedCorners,
    removeArrow,
    alignText,
    useGradient,
    backgroundGradient,
    gradientDirection,
    imageFormat
  } = element;
  const { slug, imagePattern } = url;
  const translations = window.campaign_data.campaign_translations.blocks;
  const commonTranslations = window.campaign_data.common_translations.blocks;
  const techPattern = `${imagePattern.split('.')[0]}${imageFormat || '.png'}`;
  let techBackground = `0${5 + Number(techNumber)}0-tech${techNumber}`;
  if (techNumber === 'kids') {
    techBackground = '100-kids';
  } else if (techNumber === '5') {
    techBackground = '105-tech5';
  } else if (techNumber.includes('extra')) {
    techBackground = `20${techNumber.split('-')[1]}-${techNumber
      .split('-')
      .join('')}`;
  }
  if (campaignType === 'general') techBackground = `060-tech${techNumber}`;
  const uppercaseLetters = url.generalData
    ? url.generalData.uppercaseLetters
    : false;

  let displayTextColor = textColor;
  let displayTitleColor = titleColor;
  if (useMobileText && window.innerWidth < 768)
    displayTextColor = mobileTextColor;
  if (useMobileText && window.innerWidth < 768)
    displayTitleColor = mobileTitleColor;
  const roundTheCorners =
    campaignType === 'general' && roundedCorners ? 'rounded-corners' : '';

  const classes = uppercaseLetters
    ? 'techTitle title title--uppercase'
    : 'techTitle title';

  let techTitle;
  let techText;
  let techLink;
  let techImage;
  if (campaignType === 'general') {
    techTitle = translations[`tech${techNumber}title`];
    techText = translations[`tech${techNumber}text`];
    techLink = translations[`tech${techNumber}link`];
    techImage = `tech${techNumber}`;
  } else {
    switch (techNumber) {
      case 'kids':
        techTitle = translations.juniortitle;
        techText = translations.juniortext;
        techLink = translations.linkjunior;
        techImage = 'kids';
        break;
      case '4':
        techTitle = translations.statement2ndtitle;
        techText = translations.statement2ndtext;
        techLink = translations.linkstatement2nd;
        techImage = 'tech4';
        break;
      case '5':
        techTitle = translations.messititle;
        techText = translations.messitext;
        techLink = translations.linkmessi;
        techImage = 'tech5';
        break;
      case (techNumber.match(/extra-\d/) || {}).input:
        techTitle = translations[`tech${techNumber.split('-').join('')}title`];
        techText = translations[`tech${techNumber.split('-').join('')}text`];
        techLink =
          translations[`tech${techNumber.split('-').join('')}link`] ||
          translations.linkcategory;
        techImage = `tech${techNumber}`;
        break;
      default:
        techTitle = translations[`tech${techNumber}title`];
        techText = translations[`tech${techNumber}text`];
        techLink = translations.linkcategory;
        techImage = `tech${techNumber}`;
    }
  }
  let styler = {};
  if (noBackground && useGradient && gradientDirection === 'leftToRight') {
    styler = {
      background: `linear-gradient(to right, ${backgroundColor} 0%, ${backgroundGradient} 100%)`
    };
  } else if (
    noBackground &&
    useGradient &&
    gradientDirection === 'topToBottom'
  ) {
    styler = {
      background: `linear-gradient(${backgroundColor} 0%, ${backgroundGradient} 100%)`
    };
  } else if (noBackground && !useGradient) {
    styler = { background: backgroundColor };
  } else {
    styler = {};
  }

  return !hide ? (
    <section
      id={anchorName || ''}
      className={
        noBackground
          ? `component tech-section ${
              campaignType === 'general' ? 'generalTech' : 'smart-section'
            }`
          : 'component tech-section'
      }
      style={styler}
      dataorder={order}
      datatype={type}
    >
      {!noBackground && (
        <SmartImage
          className={campaignType === 'general' ? 'heightBackground' : ''}
          slug={slug}
          name={`${techBackground}${imagePattern}`}
          version={version}
          campaignType={campaignType}
          alt={findAltText(`Tech Background ${techNumber}`, techTitle)}
        />
      )}
      <div className="mainWidth">
        {techNumber === 'kids' && window.innerWidth < 768 ? (
          <React.Suspense fallback={null}>
            <KidsCorner
              lang={window.campaign_data.common_translations.language}
              color={kidsColor}
            />
          </React.Suspense>
        ) : null}
        {noBackground && (
          <div
            data-animation-type={imageAnimation}
            className={`${
              position === 'left'
                ? 'tech-pictureholder right'
                : 'tech-pictureholder left'
            }`}
          >
            <picture>
              <source
                media="(min-width: 768px)"
                srcSet={`${slug}tech/desktop/${techImage}${techPattern}?version=${version}`}
              />
              <img
                src={`${slug}tech/mobile/${techImage}${techPattern}?version=${version}`}
                alt={findAltText(`Tech Image ${techNumber}`, techTitle)}
              />
            </picture>
          </div>
        )}

        <div
          data-animation-type={textAnimation}
          className={`tech-textholder ${position} ${
            campaignType === 'general' ? 'holderWidth' : ''
          } ${
            campaignType === 'general' && alignText ? 'alignTextBottom' : ''
          }`}
        >
          {techNumber === 'kids' && window.innerWidth >= 768 ? (
            <React.Suspense fallback={null}>
              <KidsCorner
                lang={window.campaign_data.common_translations.language}
                color={kidsColor}
              />
            </React.Suspense>
          ) : null}
          <h2 className={classes} style={{ color: displayTitleColor }}>
            {techTitle}
          </h2>
          <p className="techText text" style={{ color: displayTextColor }}>
            {techText}
          </p>
          {!isBootroom && (
            <Cta
              className={roundTheCorners}
              url={techLink}
              translation={commonTranslations.shopnow}
              backgroundColor={cta.ctaBackgroundColor}
              textColor={cta.ctaTextColor}
              ctaArrowColor={cta.ctaArrowColor}
              borderColor={cta.ctaBorderColor}
              noArrow={removeArrow}
              campaignType={campaignType}
            />
          )}
        </div>
      </div>
    </section>
  ) : null;
}
export default Tech;
